import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import UserCategory from './Components/UserCategory'
import UserShowMoreButton from './Components/UserShowMoreButton'

class UserItemsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.setInitialState()

    this.setInitialState = this.setInitialState.bind(this)
  }

  componentDidMount() {
    const newState = this.state

    newState.categories.forEach((category) => {
      axios.get(`/api/internal/profile/${this.props.userName}/items`, {
        params: {
          category: category.category,
          perPage: this.state.itemsPerCategory * this.state.rowsPerCategory,
          page: 1,
        },
      }).then(res => {
        category.items = res.data.data
        newState.loadedModels += res.data.data.length
        this.setState({ ...newState })
      }).catch(this.onRequestFailure)
    })
  }

  setInitialState() {
    const categories = this.setCategories(this.props.userTotals.itemCategories).filter((item) => item)

    return {
      itemsPerCategory: 5,
      categories,
      rowsPerCategory: this.coutItemsPerCategory(categories.length),
      loadedModels: 0,
    }
  }

  setCategories(categories) {
    return (
      Object.keys(categories).map((key) => {
        if (categories[key].count > 0) {
          return {
            category: key,
            title: categories[key].title,
            categoryCount: categories[key].count,
            categoryFilter: categories[key].filter,
            items: [],
          }
        }
      })
    )
  }

  onRequestFailure() {
    App.events.publish('app:notification:flash:error', 'Error')
  }

  coutItemsPerCategory(categories) {
    switch (categories) {
      case 2:
        return (2)
      default:
        return (4)
    }
  }

  render() {
    return (
      <Fragment>
        {this.state.categories.map((category) => (
          <UserCategory
            key={`user-models-category-${category.category}`}
            userName={this.props.userName}
            category={category}
            cart={this.props.cart}
            isDisplayedInCarouselle
            locale={this.props.locale}
          />
        ))}
        {this.props.userTotals.paidModelCount > this.state.loadedModels && this.state.loadedModels > 0 && (
          <UserShowMoreButton
            userName={this.props.userName}
            modelCount={this.props.userTotals.modelCount}
            locale={this.props.locale}
            categories={this.state.categories}
          />
        )}
      </Fragment>
    )
  }
}

UserItemsList.propTypes = {
  userName: PropTypes.string.isRequired,
  userTotals: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
}

export default UserItemsList
